import { withInjectedProps } from 'Components/Core/InjectedPropsContext';
import { valueOrDefault } from 'Lib/Any';
import React from 'react';
import { useSelector } from 'react-redux';
import { pipe } from 'rxjs';
import { IWorksheetComponent, WorksheetsResultsMessagesSection } from '../../../Core';
import CompactionControlSection from './Results/CompactionControlSection';
import CorrectedForOversizeResults from './Results/CorrectedForOversizeResults';
import FieldResults from './Results/FieldResults';
import LaboratoryResults from './Results/LaboratoryResultsSection';
import SampleResults from './Results/SampleResults';
let AsResultsSection: React.FC<IWorksheetComponent> = ({ createWorksheetSelector }) => {
  const OversizeCorrectionApplies = useSelector(
    pipe(createWorksheetSelector!('OversizeCorrectionData.OversizeCorrectionApplies'), valueOrDefault(false))
  ) as boolean;
  return (
    <>
      <WorksheetsResultsMessagesSection />
      <SampleResults />
      <FieldResults />
      <LaboratoryResults />
      {OversizeCorrectionApplies && <CorrectedForOversizeResults />}
      <CompactionControlSection />
    </>
  );
};

AsResultsSection = withInjectedProps(AsResultsSection);

export { AsResultsSection };
export default AsResultsSection;
